import { SVGProps } from 'react';

export const FileDocFillIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <span className="anticon">
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 4800 4800"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g>
          <path fill="#3980FB" d="M0 4800h3800V840L2960 0H0" />
          <path fill="#9EC2FF" d="M2960 840h840L2960 0" />
          <path fill="#1F53B1" d="M3800 1680V840h-840" />
        </g>
        <g>
          <path
            fill="#FFF"
            d="M900 1976h2000v-212H900m0 670h2000v-211H900m0 670h2000v-212H900m0 635h1200v-176H900"
          />
        </g>
      </svg>
    </span>
  );
};
